function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "h83p82giqa",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 6
}), /*#__PURE__*/React.createElement("rect", {
  id: "e3iudz34lb",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 5.333
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#F7F5F0",
  xlinkHref: "#h83p82giqa"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ja5te6ayic",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e3iudz34lb"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#ja5te6ayic)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.407 6.387c0-2.394-1.936-4.262-4.327-4.262H7.202C4.872 2.19 3 4.035 3 6.387a4.326 4.326 0 0 0 4.202 4.326h5.172l1.955 1.185a.28.28 0 0 0 .422-.237V10.38a4.323 4.323 0 0 0 2.656-3.992z",
  fill: "#E74536"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.314 6.693h-3.687a3.688 3.688 0 0 0-3.686 3.69 3.69 3.69 0 0 0 2.265 3.407v1.036a.24.24 0 0 0 .363.205l1.569-.953h3.176A3.688 3.688 0 0 0 29 10.388a3.695 3.695 0 0 0-3.686-3.695z",
  fill: "#FFB511"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.523 21.426-1.347-4.22v-1.613a3.01 3.01 0 0 0-3.008-3.011H8.33a3.01 3.01 0 0 0-3.009 3.011v3.644c0 .088.005.176.014.265V30h6.681v-5.814h2.958c.083 0 .153-.07.153-.153v-1.77h1.778a.646.646 0 0 0 .618-.837z",
  fill: "#0F1941"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.826 19.878a3.36 3.36 0 0 0-3.357-3.36 3.36 3.36 0 0 0 0 6.72c.098 0 .19-.005.284-.014l1.16.707c.065.037.144-.01.144-.08v-1.013a3.36 3.36 0 0 0 1.77-2.96z",
  fill: "#E74536"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.508 7.033a.646.646 0 1 0 0-1.292.646.646 0 0 0 0 1.292zm2.633 0a.646.646 0 1 0 0-1.292.646.646 0 0 0 0 1.292zm2.628 0a.646.646 0 1 0-.001-1.292.646.646 0 0 0 0 1.292z",
  fill: "#F7F5F0"
})));
function SvgAppIllus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIllus);
export default __webpack_public_path__ + "static/media/AppIllus.2afb0895.svg";
export { ForwardRef as ReactComponent };